module.exports = __webpack_public_path__ + "static/media/welcome.14ca7f24.png";